import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:    <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:   <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    Search:       <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    MapPin:       <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    Star:         <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    Shield:       <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>,
    Award:        <><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></>,
    Search2:      <><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></>,
    Calendar:     <><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></>,
    Lock:         <><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    MessageCircle:<><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></>,
    Hammer:       <><path d="m15 12-8.5 8.5a2.12 2.12 0 1 1-3-3L12 9"/><path d="M17.64 15 22 10.64"/><path d="m20.91 11.7-1.25-1.25c-.6-.6-.93-1.4-.93-2.25v-.86L16.01 4.6a5.56 5.56 0 0 0-3.94-1.64H9l.92.82A6.18 6.18 0 0 1 12 8.4v1.56l2 2h2.47l2.26 1.91"/></>,
    Sofa:         <><path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z"/><path d="M4 18v2M20 18v2"/></>,
    Archive:      <><rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/></>,
    DoorOpen:     <><path d="M13 4h3a2 2 0 0 1 2 2v14"/><path d="M2 20h3"/><path d="M13 20h9"/><path d="M10 12v.01"/><path d="M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z"/></>,
    Layers:       <><path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/></>,
    Sparkles:     <><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3z"/></>,
    ChevronDown:  <><path d="m6 9 6 6 6-6"/></>,
    ChevronUp:    <><path d="m18 15-6-6-6 6"/></>,
    Briefcase:    <><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ── Avatar ── */
function Avatar({ name, size = 42 }) {
  const initials = name.split(" ").map(w => w[0]).slice(0, 2).join("");
  const colors = [
    { bg: T.g50, text: T.g700, border: T.g100 },
    { bg: "#fff7ed", text: "#c2410c", border: "#fed7aa" },
    { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
  ];
  const color = colors[name.charCodeAt(0) % colors.length];
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", flexShrink: 0, background: color.bg, border: `1.5px solid ${color.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.35, fontWeight: 600, color: color.text, fontFamily: T.sans }}>
      {initials}
    </div>
  );
}

function Stars({ rating, size = 13 }) {
  return (
    <div style={{ display: "inline-flex", gap: 2 }}>
      {[1, 2, 3, 4, 5].map(i => (
        <svg key={i} width={size} height={size} viewBox="0 0 24 24" fill={i <= rating ? T.amber : T.n150} stroke="none">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
  );
}

/* ── Location search bar ── */
function LocationSearchBar() {
  const navigate = useNavigate();
  const [location, setLocation] = useState("");

  const handleSearch = () => {
    const params = new URLSearchParams({ category: "carpentry-furniture" });
    if (location.trim()) params.set("location", location.trim());
    navigate(`/search?${params.toString()}`);
  };

  return (
    <div style={{ display: "flex", gap: 10, maxWidth: 520, flexWrap: "wrap" }}>
      <div style={{ position: "relative", flex: "1 1 260px" }}>
        <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
          <Icon name="MapPin" size={16} color={T.n400} strokeWidth={2} />
        </span>
        <input
          type="text"
          value={location}
          onChange={e => setLocation(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleSearch()}
          placeholder="Enter your area or estate"
          style={{
            width: "100%", padding: "14px 14px 14px 42px",
            border: `1.5px solid ${T.n150}`, borderRadius: 12,
            fontSize: 14, fontFamily: T.sans, color: T.n900,
            background: T.white, outline: "none", boxSizing: "border-box",
          }}
          onFocus={e => (e.target.style.borderColor = T.g500)}
          onBlur={e => (e.target.style.borderColor = T.n150)}
        />
      </div>
      <button onClick={handleSearch} style={{
        display: "inline-flex", alignItems: "center", gap: 8,
        padding: "14px 24px", background: T.g500, color: T.white,
        border: "none", borderRadius: 12, fontSize: 14, fontWeight: 600,
        fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
      }}
      onMouseEnter={e => (e.currentTarget.style.background = T.g600)}
      onMouseLeave={e => (e.currentTarget.style.background = T.g500)}>
        <Icon name="Search" size={16} color={T.white} strokeWidth={2} />
        Find a carpenter
      </button>
    </div>
  );
}

/* ── Sub-service card ── */
const SUB_SERVICES = [
  { icon: "Hammer",   name: "Furniture repair",               price: "KES 1,000 – 5,000",   unit: "per item",   desc: "Fixing broken chairs, tables, cabinets, and other household furniture." },
  { icon: "Sofa",     name: "Custom furniture making",         price: "KES 8,000 – 60,000",  unit: "per project", desc: "Bespoke tables, beds, sofas, and furniture pieces built to your specifications." },
  { icon: "Archive",  name: "Cabinet & wardrobe installation",  price: "KES 6,000 – 35,000",  unit: "per unit",   desc: "Fitted wardrobes, kitchen cabinets, and storage units installed to measure." },
  { icon: "DoorOpen", name: "Door & window fitting",           price: "KES 2,500 – 12,000",  unit: "per unit",   desc: "Installation, replacement, and adjustment of wooden doors and window frames." },
  { icon: "Layers",   name: "Shelving & storage",               price: "KES 2,000 – 10,000",  unit: "per project", desc: "Custom shelving, bookcases, and storage solutions built for your space." },
  { icon: "Sparkles", name: "Wood polishing & refinishing",     price: "KES 1,500 – 7,000",   unit: "per item",   desc: "Sanding, staining, and varnishing to restore or refresh wooden furniture." },
];

function SubServiceCard({ s }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: "22px", borderRadius: 16,
        border: `1.5px solid ${hovered ? T.g200 : T.n150}`,
        background: hovered ? T.g50 : T.white,
        transition: "all .15s",
      }}>
      <div style={{ width: 42, height: 42, borderRadius: 12, background: T.g50, border: `1.5px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 14 }}>
        <Icon name={s.icon} size={19} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 6 }}>{s.name}</div>
      <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.65, margin: "0 0 14px" }}>{s.desc}</p>
      <div style={{ display: "flex", alignItems: "baseline", gap: 6, paddingTop: 12, borderTop: `1px solid ${T.n100}` }}>
        <span style={{ fontFamily: T.serif, fontSize: 17, fontWeight: 400, color: T.g700, letterSpacing: "-0.01em" }}>{s.price}</span>
        <span style={{ fontSize: 12, color: T.n400 }}>{s.unit}</span>
      </div>
    </div>
  );
}

/* ── How it works step ── */
function HowStep({ num, icon, title, desc }) {
  return (
    <div style={{ display: "flex", gap: 18, padding: "22px 0", borderBottom: `1px solid ${T.n100}` }}>
      <div style={{ width: 42, height: 42, borderRadius: 12, background: T.g50, border: `1.5px solid ${T.g100}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Icon name={icon} size={18} color={T.g500} strokeWidth={1.6} />
      </div>
      <div style={{ flex: 1, paddingTop: 2 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 5 }}>Step {num}</div>
        <div style={{ fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 5 }}>{title}</div>
        <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: 0 }}>{desc}</p>
      </div>
    </div>
  );
}

/* ── Trust row ── */
function TrustRow({ icon, title, desc }) {
  return (
    <div style={{ display: "flex", gap: 16, padding: "18px 0", borderBottom: `1px solid ${T.n100}` }}>
      <div style={{ width: 38, height: 38, borderRadius: 10, background: T.white, border: `1px solid ${T.g200}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Icon name={icon} size={16} color={T.g500} strokeWidth={1.7} />
      </div>
      <div style={{ flex: 1, paddingTop: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: T.n800, marginBottom: 3 }}>{title}</div>
        <div style={{ fontSize: 14, color: T.n600, lineHeight: 1.65 }}>{desc}</div>
      </div>
    </div>
  );
}

/* ── Testimonial ── */
function Testimonial({ name, location, rating, text }) {
  return (
    <div style={{ padding: "22px", borderRadius: 16, border: `1px solid ${T.n150}`, background: T.white, display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Avatar name={name} />
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.n900 }}>{name}</div>
          <div style={{ fontSize: 12, color: T.n400 }}>{location}</div>
        </div>
      </div>
      <Stars rating={rating} />
      <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: 0, fontStyle: "italic" }}>"{text}"</p>
    </div>
  );
}

/* ── FAQ ── */
function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 0", background: "none", border: "none", cursor: "pointer", fontFamily: T.sans, textAlign: "left", gap: 16 }}>
        <span style={{ fontSize: 15, fontWeight: 600, color: T.n800, lineHeight: 1.4 }}>{q}</span>
        <span style={{ flexShrink: 0, color: T.n400 }}><Icon name={open ? "ChevronUp" : "ChevronDown"} size={18} strokeWidth={2} /></span>
      </button>
      {open && <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.75, margin: "0 0 18px", paddingRight: 32 }}>{a}</p>}
    </div>
  );
}

/* ── Section head ── */
function SectionHead({ eyebrow, title, em, sub }) {
  return (
    <div style={{ marginBottom: 6 }}>
      <span style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", display: "block", marginBottom: 6 }}>{eyebrow}</span>
      <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
        {title} <em style={{ fontStyle: "italic", color: T.g600 }}>{em}</em>
      </h2>
      {sub && <p style={{ fontSize: 15, color: T.n400, margin: 0, lineHeight: 1.65 }}>{sub}</p>}
    </div>
  );
}

/* ══ Main page ══ */
export default function CarpentryFurniturePage() {
  useFonts();
  const navigate = useNavigate();

  const faqs = [
    { q: "How is pricing determined for carpentry work?", a: "Repairs and smaller jobs like shelving are typically priced per item or per project based on materials and complexity. Custom furniture and large installations such as wardrobes are quoted after the carpenter assesses your requirements, measurements, and material preferences. Pricing is always confirmed before the job begins." },
    { q: "Do I need to supply the wood and materials myself?", a: "This varies by job. For repairs and small fixes, most carpenters use materials they already have. For custom furniture, cabinets, or larger installations, the carpenter will usually source materials and include that cost in the quote, unless you prefer to supply your own, which can be discussed directly with them." },
    { q: "How long does custom furniture take to complete?", a: "Timelines depend on the complexity and size of the piece. A simple repair might be same-day, while custom furniture such as a bed frame or wardrobe can take anywhere from a few days to a couple of weeks. Your carpenter will give you an estimated timeline before you confirm the booking." },
    { q: "Can a carpenter come to measure my space before quoting?", a: "Yes. For installations like fitted wardrobes, cabinets, or custom shelving, it is common and recommended to have the carpenter visit and take measurements before confirming a final price. You can arrange this through in-app messaging after viewing their profile." },
    { q: "What if the finished furniture does not match what was agreed?", a: "If the delivered work does not match what was discussed and agreed, raise a dispute within 48 hours of completion through the Help and Support page. Our Trust and Safety team will review photos, messages, and the original agreement to reach a fair resolution under the Jirani Guarantee." },
    { q: "Can carpenters repair antique or specialty furniture?", a: "Many JiraniPros listed under carpentry have experience with antique restoration and specialty pieces, but this is not guaranteed across all profiles. Check the carpenter's portfolio photos and message them directly to confirm experience with your specific type of furniture before booking." },
  ];

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900 }}>
      <style>{`* { box-sizing: border-box; }`}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "20px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        <button onClick={() => navigate(-1)} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: "none", cursor: "pointer", color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0 }}
          onMouseEnter={e => (e.currentTarget.style.color = T.n800)}
          onMouseLeave={e => (e.currentTarget.style.color = T.n400)}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => navigate("/pro-onboarding")} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.g600, fontSize: 13, fontFamily: T.sans, fontWeight: 600, padding: 0,
        }}>
          <Icon name="Briefcase" size={14} strokeWidth={2} />
          Are you a carpenter? Join JiraniApp
        </button>
      </div>

      {/* ── Hero ── */}
      <div style={{ padding: "clamp(48px,7vw,84px) 20px clamp(40px,5vw,56px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 7, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 20 }}>
            <Icon name="Hammer" size={14} color={T.g500} strokeWidth={2.2} />
            Carpentry & Furniture
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(38px,7vw,60px)", fontWeight: 400, margin: "0 0 18px", lineHeight: 1.08, color: T.n900, letterSpacing: "-0.03em", maxWidth: 580 }}>
            Craftsmanship you{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>can trust</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.75, margin: "0 0 32px", maxWidth: 520 }}>
            From furniture repairs to bespoke pieces built to your exact specifications, find
            verified carpenters near you with transparent pricing and real reviews.
          </p>
          <LocationSearchBar />
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px clamp(80px,10vw,120px)" }}>

        {/* ── Sub-services grid ── */}
        <div style={{ paddingTop: "clamp(40px,6vw,56px)", marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="Services" title="What carpenters on" em="JiraniApp do" sub="Pricing varies by material, size, and complexity. These are typical ranges." />
          <div style={{ marginTop: 20, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 14 }}>
            {SUB_SERVICES.map(s => <SubServiceCard key={s.name} s={s} />)}
          </div>
        </div>

        {/* ── How it works ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="How it works" title="Booking a carpenter," em="step by step" sub="From search to finished furniture in four simple steps." />
          <div style={{ marginTop: 8 }}>
            <HowStep num="01" icon="Search2" title="Search and compare carpenters near you" desc="Enter your area and browse verified carpenters with ratings, portfolio photos of past work, and transparent pricing for each service type." />
            <HowStep num="02" icon="Calendar" title="Book a date and describe the job" desc="Choose a time that works for you and describe what you need — a repair, a custom piece, or an installation. For larger projects, message the carpenter first to confirm measurements and materials." />
            <HowStep num="03" icon="Hammer" title="Your carpenter gets to work" desc="Track the job status in the app and message your carpenter directly if anything needs adjusting. Payment is held securely until the job is done to your satisfaction." />
            <HowStep num="04" icon="Star" title="Rate your experience" desc="Once complete, leave a rating and review of the finished work. Happy with the result? Save your carpenter's profile for future projects." />
          </div>
        </div>

        {/* ── Trust section ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)", padding: "clamp(28px,5vw,40px)", borderRadius: 20, background: T.g50, border: `1px solid ${T.g100}` }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 7, color: T.g600, fontSize: 11, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 14 }}>
            <Icon name="Shield" size={13} color={T.g500} strokeWidth={2} />
            Jirani Guarantee
          </div>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(22px,3.5vw,28px)", fontWeight: 400, color: T.n900, margin: "0 0 6px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Every booking is <em style={{ fontStyle: "italic", color: T.g600 }}>protected</em>
          </h2>
          <p style={{ fontSize: 14, color: T.n600, margin: "0 0 8px", lineHeight: 1.65 }}>How we keep carpentry bookings safe and reliable.</p>
          <div style={{ marginTop: 10 }}>
            <TrustRow icon="Award" title="ID verified carpenters" desc="Every carpenter on JiraniApp completes identity verification before their profile goes live, so you know exactly who is working in your home." />
            <TrustRow icon="Star" title="Reviews from real bookings" desc="All ratings and reviews are tied to completed, verified jobs. Browse portfolio photos and read what other clients say before you book." />
            <TrustRow icon="Lock" title="Secure payment held until completion" desc="Your payment is held securely and only released to the carpenter once the work is marked complete to your satisfaction." />
            <TrustRow icon="MessageCircle" title="48-hour dispute resolution" desc="If the finished work does not meet what was agreed, raise it within 48 hours and our Trust and Safety team will review and resolve it fairly." />
          </div>
        </div>

        {/* ── Testimonials ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="Client stories" title="What clients" em="are saying" />
          <div style={{ marginTop: 20, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 14 }}>
            <Testimonial name="Winnie A." location="Bamburi, Mombasa" rating={5} text="Joseph repaired three pieces of furniture I thought were beyond saving. The craftsmanship is genuinely impressive and he clearly enjoys the work." />
            <Testimonial name="Tom K." location="Kileleshwa, Nairobi" rating={5} text="Had a custom bookshelf made for an awkward alcove in my living room. The measurements were perfect and the finish looks better than I imagined." />
            <Testimonial name="Janet O." location="Milimani, Kisumu" rating={4} text="Booked for a wardrobe installation. The carpenter was professional and the wardrobe fits perfectly. Took a day longer than quoted but worth the wait." />
          </div>
        </div>

        {/* ── FAQ ── */}
        <div style={{ marginBottom: "clamp(48px,7vw,72px)" }}>
          <SectionHead eyebrow="Questions" title="Common" em="questions" sub="Things clients ask before booking a carpenter." />
          <div style={{ marginTop: 8 }}>
            {faqs.map((f, i) => <FaqItem key={i} {...f} />)}
          </div>
        </div>

        {/* ── CTA ── */}
        <div style={{ padding: "clamp(32px,5vw,48px)", borderRadius: 20, border: `1px solid ${T.n150}`, textAlign: "center", background: T.n50 }}>
          <h2 style={{ fontFamily: T.serif, fontSize: "clamp(26px,4vw,36px)", fontWeight: 400, color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
            Ready to build something{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>great?</em>
          </h2>
          <p style={{ fontSize: 15, color: T.n400, margin: "0 0 28px", lineHeight: 1.65 }}>
            Browse verified carpenters near you and book in minutes.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => navigate("/search?category=carpentry-furniture")} style={{
              padding: "13px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 11, fontSize: 14, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8,
            }}
            onMouseEnter={e => (e.currentTarget.style.background = T.g600)}
            onMouseLeave={e => (e.currentTarget.style.background = T.g500)}>
              Find a carpenter
              <Icon name="ArrowRight" size={15} color={T.white} strokeWidth={2} />
            </button>
            <button onClick={() => navigate("/how-it-works")} style={{
              padding: "13px 28px", background: "transparent", color: T.n700,
              border: `1.5px solid ${T.n200}`, borderRadius: 11, fontSize: 14, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
            }}
            onMouseEnter={e => (e.currentTarget.style.borderColor = T.n400)}
            onMouseLeave={e => (e.currentTarget.style.borderColor = T.n200)}>
              How JiraniApp works
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}